import { Injectable } from '@angular/core';
import { RtlsModels } from '@rtls/core/models/rtls/rtls-models';
import { RtlsServiceDecorator } from '@rtls/core/models/rtls/rtls-service.decorator';
import { RtlsService } from '@rtls/core/models/rtls/rtls-service.model';
import { RuleSetting } from '@rtls/core/models/rule/rule-setting.model';

@Injectable()
export class RulesService extends RtlsServiceDecorator<RuleSetting> {
	constructor(rtlsService: RtlsService<RuleSetting>) {
		super(rtlsService.useModel(RtlsModels.Rules));
	}
}
